import { render, staticRenderFns } from "./PetsAllowedIconComp.vue?vue&type=template&id=4b53e666&"
import script from "./PetsAllowedIconComp.vue?vue&type=script&lang=js&"
export * from "./PetsAllowedIconComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b53e666')) {
      api.createRecord('4b53e666', component.options)
    } else {
      api.reload('4b53e666', component.options)
    }
    module.hot.accept("./PetsAllowedIconComp.vue?vue&type=template&id=4b53e666&", function () {
      api.rerender('4b53e666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5ZoDM6J7kvH/JS/comp/PetsAllowedIconComp.vue"
export default component.exports